module.exports = __webpack_public_path__ + "img/IMG_2614_T_L_BlackMatted_MockedUp.8aa2238f.jpg";